import { snapshot } from 'valtio';
import ConnectionsStore from '../stores/connections-store';
import { Connection } from '../types/connection-types';

export const setConnections = (connections: Connection[]) => {
  ConnectionsStore.connections = connections;
};

export const setLoadingConnections = (isLoading: boolean) => {
  ConnectionsStore.isLoading = isLoading;
};

export const updateConnections = (connection: Connection) => {
  const { connections } = snapshot(ConnectionsStore);

  const updatedConnections = connections.map(c => {
    if (c.strategy === connection.strategy) {
      return connection;
    }
    return c;
  });

  ConnectionsStore.connections = updatedConnections;
};

export const getConnections = () => {
  const { connections } = snapshot(ConnectionsStore);
  return connections;
};

export const setErrorMessage = (message: string) => {
  ConnectionsStore.errorMessage = message;
};

export const clearErrorMessage = () => {
  ConnectionsStore.errorMessage = null;
};
